import React from "react";

import ForgotPasswordForm from "./Components/FormControl/ForgotPasswordForm";

import AuthLayout from "@/Components/Layouts/Native/AuthLayout";

export default function ForgotPasswordScreen(): React.JSX.Element {
  return (
    <AuthLayout>
      <ForgotPasswordForm />
    </AuthLayout>
  );
}
